import React, {useEffect, useState} from 'react';
import {Field, useFormikContext} from 'formik';
import {TextField} from 'formik-mui';
import {Autocomplete} from '@mui/material';
import Card from '@mui/material/Card';
import {museumApi} from '../../../../services/MuseumServices';

export default function TransferEntryThreeUpdate({code, id}) {
  const {values, setFieldValue} = useFormikContext();
  const [museums, setMuseums] = useState([]);

  useEffect(() => {
    getMuseumList();
  }, []);

  const getMuseumList = () => {
    museumApi('get', null, {per_page: 100}).then(response => {
      setMuseums(response?.data);
    })
  }

  const getSelectedMuseum = (recipientMuseumId) => {
    return museums?.find(val => parseInt(val?.id) === parseInt(recipientMuseumId)) || null;
  }

  return (
    <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 5}}>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Condition'}
             name={`condition`} disabled
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Storage Location'}
             name={`location`} sx={{mt: 1.5}} disabled
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Place of Origin'}
             name={`place_of_origin`} sx={{mt: 1.5, mb: 1.5}} disabled
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
      <Autocomplete
        id="combo-box-demo"
        options={museums}
        value={getSelectedMuseum(values?.recipient_museum_id)}
        getOptionLabel={(option) => (option?.name)}
        size={'small'}
        className="dob mr-2 mt-3"
        onChange={(e, value) => {
          setFieldValue('recipient_museum_id', value?.id || null);
        }}
        renderInput={(params) => <Field component={TextField} {...params}
                                        placeholder="Select Museum"
                                        label={
                                          <div>
                                            <span style={{color: 'red'}}>*</span>
                                            Select recipient museum
                                          </div>
                                        }
                                        InputLabelProps={{style: {color: '#929191', fontSize: 14}}}
                                        name="recipient_museum_id"/>}
      />
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth
             label={
               <div>
                 <span style={{color: 'red'}}>*</span>
                 Justification
               </div>
             }
             name={`remarks`} sx={{mt: 1.5}} multiline minRows={5} maxRows={10}
             InputLabelProps={{
               style: {fontSize: 14, color: '#929191'},
               shrink: true
             }}/>
    </Card>
  );
}